"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseSwaggerDocumentation = void 0;
var tslib_1 = require("tslib");
var parseSwaggerDocumentation_1 = require("./parseSwaggerDocumentation");
Object.defineProperty(exports, "parseSwaggerDocumentation", { enumerable: true, get: function () { return tslib_1.__importDefault(parseSwaggerDocumentation_1).default; } });
tslib_1.__exportStar(require("./parseSwaggerDocumentation"), exports);
//# sourceMappingURL=index.js.map